export default __webpack_public_path__ + "static/media/template-3.5d5e2972.png";